// extracted by mini-css-extract-plugin
module.exports = {"nav-menu":"NavBar_nav-menu__2W4wh","nav-icon":"NavBar_nav-icon__1NvVD","nav-list-item":"NavBar_nav-list-item__1dwdT","nav-icon-heart":"NavBar_nav-icon-heart__1Ofpp"};